
import React from "react";
import { NoteEntry } from "./NoteEntry";
import type { ActivityNotes, Note } from "./activityUtils";
import { hasArrayNotes, hasStringNotes } from "./activityUtils";

interface ActivityNotesListProps {
  notes: ActivityNotes;
}

export const ActivityNotesList: React.FC<ActivityNotesListProps> = ({ notes }) => {
  if (hasArrayNotes(notes)) {
    return (
      <div className="space-y-4">
        {notes.map((note, index) => (
          <NoteEntry 
            key={index} 
            date={note.date} 
            content={note.content} 
          />
        ))}
      </div>
    );
  }
  
  if (hasStringNotes(notes)) {
    return (
      <div className="space-y-4">
        <NoteEntry 
          date={new Date().toISOString()} 
          content={notes} 
        />
      </div>
    );
  }
  
  return null;
};
